import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const HeaderContainer = styled.div`
  position: fixed;
  z-index: 2000;
  top: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  background-color: ${Variables.colorWhite};
`;

export const AppLinks = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const AppLink = styled.div`
  color: #333;
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  padding: 10px 15px;
  cursor: pointer;

  &:hover::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5); /* Color semi-transparente */
    z-index: -1; /* Asegura que quede detrás del texto */
    border-bottom: 2px solid #fffb00;
  }

  @media (max-width: ${Variables.maxTablet}) {
    padding: ${({ noMedia }) => (noMedia ? `10px 15px` : `10px 0`)};
    margin-bottom: ${({ noMedia }) => (noMedia ? `0` : `5px`)};
    width: ${({ noMedia }) => (noMedia ? `auto` : `100%`)};
    background-color: ${({ noMedia }) => (noMedia ? Variables.colorWhite : `rgba(130, 130, 130, 0.3)`)};
    border-radius: ${({ noMedia }) => (noMedia ? `0` : `10px`)};
  }
`;

export const AppBold = styled.b`
  opacity: 0.6;
  color: #333;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 15px;
`;

export const ModalOptions = styled.div`
  position: absolute;
  top: 100%;
  right: 10px;
  z-index: 2000;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 200px;
  min-height: 200px;
  max-height: 600px;
  background-color: ${Variables.colorWhite};
  box-shadow: ${Variables.ShadowBlack};
  border-radius: 20px;
`;

export const Header = styled.div`
  position: fixed;
  z-index: 3000;
  top: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  width: 100%;
  height: 70px;
  background-color: ${Variables.colorGrayClear};
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: ${Variables.colorWhite};
  cursor: pointer;
`;

export const ContainerWelcome = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 45%;

  @media (min-width: 1024px) {
    width: 25%;
  }

  @media (min-width: 1440px) {
    width: 20%;
  }
`;

export const TextWelcome = styled.div`
  font-weight: 600;
  color: ${Variables.colorWhite};
`;

export const ContainerIcon = styled.div`
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

export const ContainerOptions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

export const ContainerOption = styled.div`
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  background-color: ${Variables.colorOrange};
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const TextOthers = styled.div`
  color: ${Variables.colorWhite};
  cursor: pointer;
`;

export const ButtonLogOut = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 20px;
  cursor: pointer;
  color: ${Variables.colorWhite};
`;
